enum QuestionOptionType {
    SIMPLE = 1,
    MULTIPLE = 2,
    FREE = 3,
    AFFECTIVE = 4,
    CATALOG = 5
}

export { QuestionOptionType }